import { useMemo } from "react";
import { KPI_CODES } from "../kpiCodes";

export const useGetAccWithPaymentRestrictions = (data: any) => {
  const statMap: any = useMemo(
    () => ({
      "Accounts.DoNotAllowPaymentsRestrictions": {
        label: "Do not Allow Payments",
        key: 1,
      },
      "Accounts.NFSItemOutstandingRestrictions": {
        label: "NSF Item Outstanding",
        key: 2,
      },
      "Accounts.AllowIfAllPastDueAmountIncludedRestrictions": {
        label: "Allow if All Past Due Amounts Included",
        key: 3,
      },
      "Accounts.AcceptPayoffOnlyRestrictions": {
        label: "Accept Payoff Only",
        key: 4,
      },
      "Accounts.AssignmentPendingRestrictions": {
        label: "Assignment Pending",
        key: 5,
      },
      "Accounts.CertifiedFundsOnlyRestrictions": {
        label: "Certified Funds Only",
        key: 6,
      },
    }),
    [],
  );

  const accountsStat = useMemo(() => {
    if (data) {
      return data.kpiValues
        .filter((item: any) =>
          [
            KPI_CODES.ACCOUNTS_DO_NOT_ALLOW,
            KPI_CODES.ACCOUNTS_NFS_ITEM,
            KPI_CODES.ACCOUNTS_ALLOW_IF_ALL_PAST,
            KPI_CODES.ACCOUNTS_PAYOFF_ONLY,
            KPI_CODES.ACCOUNTS_ASSIGNMENT_PENDING,
            KPI_CODES.ACCOUNTS_CERTIFIED_FUNDS_ONLY,
          ].includes(item.code),
        )
        .map((item: any) => ({
          ...item,
          Total: item.value,
          ...statMap[item.code],
        }))
        .sort((a: any, b: any) => a.key - b.key);
    }

    return null;
  }, [data, statMap]);

  return { accountsStat, statMap };
};
